import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getColorFilterConfig } from '../filters/color';

const lilcactusSizes = [
  '0-3M',
  '3-6M',
  '6-12M',
  '12-18M',
  '18-24M',
  '12-24M',

  '2T',
  '2-3T',
  '3T',
  '3T/4T',
  '4T',
  '4Y',
  '5T',
  '5',
  '5Y',
  '5Y/6Y',
  '5-6Y',
  '6T',
  '6',
  '6Y',
  '7Y',
  '7-8Y',
  '8Y',

  'Small (0-2 Years)',
  'Medium (2-4 Years)',
  'Small (3-4 Years)',
  'Medium (5-7 Years)',
  'Large (5-7 Years)',

  'Ladies S/M',
  'Ladies M/L',

  'One Size',
];

export const lilcactusShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getColorFilterConfig(),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({ sizes: lilcactusSizes }),
  ],
};
